import { useTranslation } from '@frontend/i18n';
import { TextField } from '@frontend/design-system';
import { useRuleRecurrenceForm } from '../../../hooks/settings/use-rule-recurrence-form';
import { AvailabilityFormRow } from '../availability-form/atoms/availability-form-row';
import { AvailabilityFormSection } from '../availability-form/atoms/availability-form-section';
import { AvailabilityMode, GetAvailabilityRuleFormFieldProps } from '../availability-form/types';
import { BookingRulesForm } from './organisms/booking-rules-form';
import { RuleRecurrenceForm } from './organisms/rule-recurrence-form';
import { ServicesForm } from './organisms/services-form';

type Props = {
  locationId: string | undefined;
  providerList: { value: string; label: string }[];
  operatoryList: { value: string; label: string }[];
  getFieldProps: GetAvailabilityRuleFormFieldProps;
  ruleRecurrenceFormProps: ReturnType<typeof useRuleRecurrenceForm<GetAvailabilityRuleFormFieldProps>>;
  availabilityMode: AvailabilityMode;
};

export const AvailabilityRuleForm = ({
  locationId,
  providerList,
  operatoryList,
  getFieldProps,
  ruleRecurrenceFormProps,
  availabilityMode,
}: Props) => {
  const { t } = useTranslation('schedule-settings');
  return (
    <div>
      <AvailabilityFormSection title={t('Display Name')} hasBottomBorder={false}>
        <AvailabilityFormRow>
          <TextField label={t('')} {...getFieldProps('displayName')} placeholder={t('Name')} />
        </AvailabilityFormRow>
      </AvailabilityFormSection>
      <RuleRecurrenceForm locationId={locationId} ruleRecurrenceFormProps={ruleRecurrenceFormProps} />
      <ServicesForm
        locationId={locationId}
        providerList={providerList}
        operatoryList={operatoryList}
        getFieldProps={getFieldProps}
        availabilityMode={availabilityMode}
      />
      <BookingRulesForm locationId={locationId} getFieldProps={getFieldProps} />
    </div>
  );
};
